/**
 * Wrapper around generated RTK Query API with cleaner naming.
 *
 * All endpoint references (keys, hooks, endpoint map) are derived from the
 * central definitions in `./config.ts` so generated names live in one place.
 *
 * No `enhanceEndpoints` tag setup: the single `listTradingBots` query is never
 * invalidated by a mutation (there is none in this package) — every distinct
 * `type`/`groupName`/`region` combination is already cached under its own key
 * by RTK Query's default arg-serialization, which is exactly the per-keystroke
 * re-query behaviour SKY-4521 wants.
 */
import { generatedApi } from './api.generated';
import { createEndpointExports, createHookExports } from '@skynet/data-helpers';
import type { HookExports } from '@skynet/data-helpers';
import { TRADING_BOTS_API_ENDPOINTS as cfg } from './config';

export const tradingBotsApi = generatedApi;

// Re-export hooks with cleaner names via endpoint definitions
export const hookExports: HookExports<typeof cfg, typeof tradingBotsApi> = createHookExports(
  cfg,
  tradingBotsApi,
);

// Re-export endpoints object with cleaner names for direct usage
export const tradingBotsApiEndpoints = createEndpointExports(cfg, tradingBotsApi);
